<template>
  <b-modal
    centered
    size="lg"
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container fluid>
      <b-row>
        <b-col>
          <h4 class="text-info m-2">{{ $t("globals.export_exact") }}:</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-tabs vertical pills>
          <b-tab :title="$t('globals.invoices')">
            <b-tabs>
              <b-tab :title="$t('globals.date_range')">
                <b-row>
                  <b-col>
                    <ulu-date-picker
                      range
                      class="mt-3"
                      v-model="dateRange"
                      lang="en"
                      format="DD.MM.YYYY"
                      :placeholder="$t('globals.select_range')"
                    />
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col>
                    <b-btn
                      style="float: right; margin: 0.3em;"
                      @click="dateDownload"
                      variant="success"
                      :disabled="dateDownloadDisabled"
                    >
                      {{ $t("globals.download") }}
                    </b-btn>
                    <b-btn
                      style="float: left; margin: 0.3em;"
                      @click="cancelModal"
                      variant="warning"
                    >
                      {{ $t("globals.cancel") }}
                    </b-btn>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab :title="$t('globals.from_invoice_no')">
                <b-row>
                  <b-col>
                    <b-input
                      class="mt-3"
                      v-model="invoice_no"
                      type="text"
                      :placeholder="$t('globals.from_invoice_no')"
                    >
                    </b-input>
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col>
                    <b-btn
                      style="float: right; margin: 0.3em;"
                      @click="fromLastInvoiceDownload"
                      variant="success"
                      :disabled="invoice_no.length == 0"
                    >
                      {{ $t("globals.download") }}
                    </b-btn>
                    <b-btn
                      style="float: left; margin: 0.3em;"
                      @click="cancelModal"
                      variant="warning"
                    >
                      {{ $t("globals.cancel") }}
                    </b-btn>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab :title="$t('globals.from_debiteur_no')">
                <b-row>
                  <b-col>
                    <b-input
                      class="mt-3"
                      v-model="from_debiteur_no"
                      :placeholder="$t('globals.from_debiteur_no')"
                      type="text"
                    >
                    </b-input>
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col>
                    <b-btn
                      style="float: right; margin: 0.3em;"
                      @click="newDownload"
                      variant="success"
                      :disabled="from_debiteur_no.length == 0"
                    >
                      {{ $t("globals.download") }}
                    </b-btn>
                    <b-btn
                      style="float: left; margin: 0.3em;"
                      @click="cancelModal"
                      variant="warning"
                    >
                      {{ $t("globals.cancel") }}
                    </b-btn>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab :title="$t('globals.debiteur_no')">
                <b-row>
                  <b-col>
                    <b-input
                      class="mt-3"
                      v-model="debiteur_no"
                      type="text"
                      :placeholder="$t('globals.debiteur_no')"
                    >
                    </b-input>
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col>
                    <b-btn
                      style="float: right; margin: 0.3em;"
                      @click="debiteurDownload"
                      variant="success"
                      :disabled="debiteur_no.length == 0"
                    >
                      {{ $t("globals.download") }}
                    </b-btn>
                    <b-btn
                      style="float: left; margin: 0.3em;"
                      @click="cancelModal"
                      variant="warning"
                    >
                      {{ $t("globals.cancel") }}
                    </b-btn>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </b-tab>
          <b-tab :title="$t('globals.parking_invoices')">
            <b-row>
              <b-col>
                <ulu-date-picker
                  type="month"
                  class="mt-3"
                  v-model="parkingDate"
                  lang="en"
                  format="MM.YYYY"
                  :placeholder="$t('globals.select_month')"
                />
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col>
                <b-btn
                  style="float: right; margin: 0.3em;"
                  @click="parkingDownload"
                  variant="success"
                  :disabled="parkingDownloadDisabled"
                >
                  {{ $t("globals.download") }}
                </b-btn>
                <b-btn
                  style="float: left; margin: 0.3em;"
                  @click="cancelModal"
                  variant="warning"
                >
                  {{ $t("globals.cancel") }}
                </b-btn>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import DatePicker from "vue2-datepicker";

export default {
  components: {
    "ulu-date-picker": DatePicker
  },
  props: {
    show: Boolean,
    close: Function
  },
  data() {
    return {
      dateRange: [null, null],
      from_debiteur_no: "",
      debiteur_no: "",
      invoice_no: "",
      parkingDate: null
    };
  },
  methods: {
    dateDownload() {
      let from = this.dateRange[0];
      let to = this.dateRange[1];

      from = `${from.getDate()}.${from.getMonth() + 1}.${from.getFullYear()}`;
      to = `${to.getDate()}.${to.getMonth() + 1}.${to.getFullYear()}`;

      window.open(
        `${
          this.getBackendUrl
        }/exact_export?from=${from}&to=${to}&brand=${this.getUserSystem.toLowerCase()}`,
        "_blank"
      );
      this.cancelModal();
    },
    fromLastInvoiceDownload() {
      window.open(
        `${this.getBackendUrl}/exact_export?last_invoice_no=${
          this.invoice_no
        }&brand=${this.getUserSystem.toLowerCase()}`,
        "_blank"
      );
      this.cancelModal();
    },
    newDownload() {
      window.open(
        `${this.getBackendUrl}/exact_export_customers?debiteur_no_from=${
          this.from_debiteur_no
        }&brand=${this.getUserSystem.toLowerCase()}`,
        "_blank"
      );
      this.cancelModal();
    },
    debiteurDownload() {
      window.open(
        `${this.getBackendUrl}/exact_export_customers?debiteur_no_from=${
          this.debiteur_no
        }&brand=${this.getUserSystem.toLowerCase()}`,
        "_blank"
      );
      this.cancelModal();
    },
    parkingDownload() {
      let date = `${this.parkingDate.getFullYear()}-${this.parkingDate.getMonth() +
        1}-${this.parkingDate.getDate()}`;

      window.open(
        `${
          this.getBackendUrl
        }/exact_parking_export?date=${date}&brand=${this.getUserSystem.toLowerCase()}`,
        "_blank"
      );
      this.cancelModal();
    },
    cancelModal() {
      this.dateRange = [null, null];
      this.from_debiteur_no = "";
      this.debiteur_no = "";
      this.invoice_no = "";
      this.parkingDate = null;
      this.close();
    }
  },
  computed: {
    ...mapGetters(["getBackendUrl", "getUserSystem"]),
    dateDownloadDisabled() {
      return this.dateRange[0] == null || this.dateRange[1] == null;
    },
    parkingDownloadDisabled() {
      return this.parkingDate == null;
    }
  }
};
</script>

<style></style>
